module.exports = __webpack_public_path__ + "img/kcqr.55de0ff3.png";